import { render, staticRenderFns } from "./FrameCropper.vue?vue&type=template&id=186864b4&scoped=true&"
import script from "./FrameCropper.vue?vue&type=script&lang=js&"
export * from "./FrameCropper.vue?vue&type=script&lang=js&"
import style0 from "./FrameCropper.vue?vue&type=style&index=0&id=186864b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186864b4",
  null
  
)

export default component.exports